import React, { useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import { kakaoLogin, googleLogin, appleLogin } from "../../utils/socialAuth";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import { useSocialAuth } from "../../hooks/SocialAuthProvider/SocialAuthProvider";
import { getFriendlyErrorMessage } from "../../utils/errorMessageUtils";
import "./Login.css";
import Modals from "../Modals/Modals";

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const loaction = useLocation();
  const { login } = useMembership();
  const { loadKakaoSDK, loadGoogleSDK, loadAppleSDK } = useSocialAuth();

  const clearError = () => {
    setErrorMessage("");
  };

  // 카카오 로그인 처리
  const handleKakaoLogin = async () => {
    setIsLoading("kakao");
    clearError();

    try {
      // SDK 로드 확인 및 로드
      if (!window.Kakao) {
        const sdkLoaded = await loadKakaoSDK();
        if (!sdkLoaded) {
          throw new Error("카카오 SDK 로드에 실패했습니다.");
        }
      }

      const user = await kakaoLogin(navigate);
      const accessToken =
        user?.access_token ||
        user?.accessToken ||
        localStorage.getItem("authToken") ||
        `kakao_token_${Date.now()}`;

      console.log("카카오 로그인 성공:", user);
      login(user, accessToken);

      setIsLoading(null);
      
      // if(loaction?.state === 'coupon_link') {
      //   navigate('/mypage/coupon',{state:'not_reload'});
      //   return;
      // }
      
      navigate(-1);
    } catch (error) {
      console.error("카카오 로그인 실패:", error);
      const errorMsg = getFriendlyErrorMessage(error);
      setErrorMessage(errorMsg);
      setShow(true);
      setIsLoading(null);

      if (errorMsg.includes("서버") || errorMsg.includes("백엔드")) {
        setTimeout(() => {
          alert(
            "로그인에 실패했습니다.\n\n서버 연결에 문제가 있어 로그인을 완료할 수 없습니다.\n잠시 후 다시 시도해주세요.\n\n홈으로 이동합니다."
          );
          navigate("/");
        }, 3000);
      }
    }
  };

  // 구글 로그인 처리 (기존 방식 - OAuth2 지원)
  const handleGoogleLogin = async () => {
    setIsLoading("google");
    clearError();

    try {
      // SDK 로드 확인 및 로드
      if (!window.google) {
        const sdkLoaded = await loadGoogleSDK();
        if (!sdkLoaded) {
          throw new Error("구글 SDK 로드에 실패했습니다.");
        }
      }

      const user = await googleLogin(navigate);
      const accessToken =
        user?.access_token ||
        user?.accessToken ||
        localStorage.getItem("authToken") ||
        `google_token_${Date.now()}`;
      login(user, accessToken);
      setIsLoading(null);
      // if(loaction?.state === 'coupon_link') {
      //   navigate('/mypage/coupon',{state:'not_reload'});
      //   return;
      // }
      navigate(-1);
    } catch (error) {
      console.error("구글 로그인 실패:", error);
      const errorMsg = getFriendlyErrorMessage(error);
      setShow(true);
      setErrorMessage(errorMsg);
      setIsLoading(null);

      if (errorMsg.includes("서버") || errorMsg.includes("백엔드")) {
        setTimeout(() => {
          alert(
            "로그인에 실패했습니다.\n\n서버 연결에 문제가 있어 로그인을 완료할 수 없습니다.\n잠시 후 다시 시도해주세요.\n\n홈으로 이동합니다."
          );
          navigate("/");
        }, 3000);
      }
    }
  };

  // 애플 로그인 처리
  const handleAppleLogin = async () => {
    setIsLoading("apple");
    clearError();

    try {
      // SDK 로드 확인 및 로드 (애플은 팝업 방식이므로 SDK 로드가 필요하지 않을 수 있음)
      if (!window.AppleID) {
        const sdkLoaded = await loadAppleSDK();
        if (!sdkLoaded) {
          console.warn("애플 SDK 로드에 실패했지만 팝업 방식으로 진행합니다.");
        }
      }

      const user = await appleLogin(navigate);
      const accessToken =
        user?.access_token ||
        user?.accessToken ||
        localStorage.getItem("authToken") ||
        `apple_token_${Date.now()}`;
      login(user, accessToken);
      setIsLoading(null);
      navigate("/");
    } catch (error) {
      // console.error('애플 로그인 실패 [A]:', error);
      const errorMsg = getFriendlyErrorMessage(error);
      setErrorMessage(errorMsg);
      setShow(true);
      setIsLoading(null);

      if (errorMsg.includes("서버") || errorMsg.includes("백엔드")) {
        setTimeout(() => {
          alert(
            "로그인에 실패했습니다.\n\n서버 연결에 문제가 있어 로그인을 완료할 수 없습니다.\n잠시 후 다시 시도해주세요.\n\n홈으로 이동합니다."
          );
          navigate("/");
        }, 3000);
      }
    }
  };

  return (
    <>
      <div className={`content_wrap login`}>
        <div className={`section_wrap`}>
          <div className={`sec sec_1`}>
            <h3 className={`text-center h2`}>로그인 및 회원 가입</h3>
            <div className={`text-center txt_box`}>
              <img src={`./contents/login_img.png`} alt={``} />
              <p className={`txt`}>
                나의 평범한 일상을
                <br />
                가장 특별한 책으로 남겨보세요
              </p>
            </div>
            <div className={`login_btn_group`}>
              <button className={`btn kakao`} onClick={handleKakaoLogin}>
                카카오로 3초만에 시작하기
              </button>
              <button className={`btn google`} onClick={handleGoogleLogin}>
                구글로 시작하기
              </button>
              {/*<button className={`btn apple`} onClick={handleAppleLogin}>*/}
              {/*  애플로 시작하기*/}
              {/*</button>*/}
            </div>
          </div>
        </div>
        <Modals
          message={errorMessage}
          show={show}
          onClose={(res: any) => setShow(res)}
          alertType={`default`}
        />
      </div>
    </>
  );
};

export default Login;
